export default {
  teamMemberships: undefined,
  teamMembershipsLoading: false,
  teams: undefined,
  teamsLoading: false
}
